import React, { useMemo, useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import * as auth from "../../services/auth";

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

export default function ResetPassword() {
  const query = useQuery();
  const token = query.get("token") || "";
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [ok, setOk] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const minLen = 8;
  const passOk =
    password && password.length >= minLen && password === password2;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!token) {
      setError("Token inválido o ausente.");
      return;
    }

    if (!passOk) {
      setError("Verifica que las contraseñas coincidan y cumplan el mínimo de caracteres.");
      return;
    }

    setLoading(true);
    try {
      await auth.resetPassword({ token, password });
      setOk(true);
      setTimeout(() => navigate("/login", { replace: true }), 1500);
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err?.message ||
        "No pudimos restablecer tu contraseña. Intenta nuevamente.";
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="z-auth-page">
      <div className="z-auth-shell">
        <section className="z-auth-card">
          <div className="z-auth-kicker">Seguridad</div>

          <h1 className="z-auth-title">Definir nueva contraseña</h1>

          <p className="z-auth-subtitle">
            Elige una contraseña segura para continuar tu acceso a ZEDRO.
          </p>

          {ok ? (
            <div className="z-auth-alert z-auth-alert--success">
              Tu contraseña se actualizó correctamente. Redirigiendo al inicio de sesión…
            </div>
          ) : (
            <form className="z-auth-form z-auth-stack" onSubmit={handleSubmit}>
              {error && (
                <div className="z-auth-alert z-auth-alert--error">
                  {error}
                </div>
              )}

              {!token && (
                <div className="z-auth-alert z-auth-alert--error">
                  Este enlace no es válido. Solicita uno nuevo desde{" "}
                  <Link to="/forgot-password">Recuperar contraseña</Link>.
                </div>
              )}

              <input
                className="z-auth-input"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder={`Nueva contraseña (mín. ${minLen} caracteres)`}
                required
              />

              <input
                className="z-auth-input"
                type={showPassword ? "text" : "password"}
                value={password2}
                onChange={(e) => setPassword2(e.target.value)}
                placeholder="Confirmar nueva contraseña"
                required
              />

              <label className="z-auth-check">
                <input
                  type="checkbox"
                  checked={showPassword}
                  onChange={() => setShowPassword(!showPassword)}
                />
                <span>Mostrar contraseña</span>
              </label>

              {password2 && password !== password2 && (
                <div className="z-auth-note">Las contraseñas no coinciden.</div>
              )}

              <button
                type="submit"
                disabled={!passOk || !token || loading}
                className="z-auth-btn"
              >
                {loading ? "Guardando…" : "Guardar contraseña"}
              </button>
            </form>
          )}

          <div className="z-auth-help">
            ¿Recordaste tu contraseña? <Link to="/login">Inicia sesión</Link>
          </div>
        </section>
      </div>
    </main>
  );
}